var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#1BACE4",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25,18 L23.25,17.25 C23.25,16.4215729 22.5784271,15.75 21.75,15.75 L8.25,15.75 L8.25,10.5 C8.25,10.0857864 7.91421356,9.75 7.5,9.75 L5.25,9.75 C2.76471863,9.75 0.75,11.7647186 0.75,14.25 L0.75,20.25 C0.75,21.0784271 1.42157288,21.75 2.25,21.75 L3,21.75"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 21,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 21,
    r: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21.75L15 21.75M12.187 3.492L21.628 5.929C22.4297891 6.1362772 22.9118955 6.95411232 22.705 7.756L21.393 12.839 11.952 10.4C11.5667365 10.3004708 11.2368059 10.0519412 11.0348188 9.70910704 10.8328317 9.36627287 10.7753413 8.95723006 10.875 8.572L12.75 1.313 10.571.75M15.202 6.686L14.798 8.25M19.046 7.811L18.642 9.375M17.334 11.791L15.75 15.75M21.393 12.839L21.75 15.75M8.25 14.25L.75 14.25"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupply);
export default __webpack_public_path__ + "static/media/supply.259763af8ceb970ab5c21e7b86f84a79.svg";
export { ForwardRef as ReactComponent };